
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-leader/products-services",
      function () {
        return require("private-next-pages/industry-leader/products-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-leader/products-services"])
      });
    }
  